import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Box, Paper } from '@mui/material'
import ButtonList from 'components/generic/buttons/ButtonList'
import BasicDataGrid from 'components/generic/datagrid'
import { PAGE_SIZE } from 'utils/constants'

const DataGridWithActionButtons = ({
  width,
  height,
  leftActionButtons,
  rightActionButtons,
  customPageSize,
  ...restProps
}) => {
  const [pageSize, setPageSize] = useState(customPageSize)

  return (
    <Paper elevation={0} sx={{ width, height, backgroundColor: 'background.default' }} data-testid="action-grid">
      <Box
        mb={2}
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <ButtonList buttonsData={leftActionButtons} />
        <ButtonList buttonsData={rightActionButtons} />
      </Box>
      <BasicDataGrid
        pageSize={pageSize}
        onPageSizeChange={newPageSize => setPageSize(newPageSize)}
        rowsPerPageOptions={[10, 20, 30]}
        pagination
        autoHeight
        {...restProps}
      />
    </Paper>
  )
}

DataGridWithActionButtons.propTypes = {
  ...BasicDataGrid.propTypes,
  leftActionButtons: PropTypes.array,
  rightActionButtons: PropTypes.array,
  customPageSize: PropTypes.number,
}

DataGridWithActionButtons.defaultProps = {
  ...BasicDataGrid.defaultProps,
  leftActionButtons: [],
  rightActionButtons: [],
  customPageSize: PAGE_SIZE,
}

export default DataGridWithActionButtons
